import { pageSelectors, usePage } from 'client/store/index'
import CommonWebinarRegistrationDate, {} from 'common/components/entities/WebinarRegistrationDate/WebinarRegistrationDate'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import React from 'react'
import BaseEntityNew from '../../../components/core/BaseEntity/BaseEntityNew'

type WebinarRegistrationDateProps = {
  entity: WebinarRegistrationDateInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function WebinarRegistrationDate({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: WebinarRegistrationDateProps) {
  const pageLocale = usePage(pageSelectors.getPageLocale)

  function changeTime() {
    return
  }

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonWebinarRegistrationDate
        attrId={entity.htmlAttrId}
        scheduledHours={entity.scheduledHours}
        timeFormat={entity.timeFormat}
        spaceBetween={entity.spaceBetween}
        interval={entity.interval}
        locale={pageLocale}
        changeTime={changeTime}
      />
    </BaseEntityNew>
  )
}

export default WebinarRegistrationDate
